<div class="itinerary-flight-container">
    <div class="airports">
        <div class="airport">
            <span class="airport_label">Saida</span>
            <span class="airport_info">
                {{ flight.flightSegments[0].originLocationCode }}<strong class="hour">{{
                    flight.flightSegments[0].departureDateTime | dateFormat: 'HH:mm' }}</strong>
            </span>
            <span class="airport_city">{{ flight.flightSegments[0].originCityName.toLowerCase() }}</span>
        </div>

        <div class="airport">
            <span class="airport_label">Chegada</span>
            <span class="airport_info">
                {{ flight.flightSegments[0].destinationLocationCode }}<strong class="hour">{{
                    flight.flightSegments[0].arrivalDateTime | dateFormat: 'HH:mm' }}</strong>
            </span>
            <span class="airport_city">{{ flight.flightSegments[0].destinationCityName.toLowerCase() }}</span>
        </div>
    </div>


    <div>
        <div class="flight-route">
            <span class="flight-route_eclipse"></span>

            <div class="flight-route_stop">
                <span class="flight-route_eclipse map-pointer"></span>
            </div>
        </div>

        <div class="flight-duration">
            <span class="flight-duration_label">Duração</span>
            <span class="flight-duration_time">{{flight.flightSegments[0].duration }}</span>
        </div>
    </div>
</div>